<template>
  <InputField
    v-if="unit === 'HOURLY' && value.rateCode === 'RG'"
    :id="id"
    v-model.number="quantity"
    :readonly="!canEdit"
    :class="canEdit ? 'tes-number-input' : 'tes-number'"
    input-type="number"
    @input="setCEValue($event)"
  />
  <InputField
    v-else-if="unit === 'HOURLY' && value.rateCode === 'CE'"
    :id="id"
    v-model.number="quantity"
    :readonly="true"
    :class="canEdit ? 'tes-number-input-disabled' : 'tes-number'"
    input-type="number"
  />
  <Checkbox
    v-else-if="unit === 'DAILY'"
    :checked="Boolean(quantity === 1)"
    :readonly="!canEdit"
    @change="onDailyChange($event)"
  />
  <InputField
    v-else
    :id="id"
    v-model.number="quantity"
    :readonly="!canEdit"
    :class="canEdit ? 'tes-number-input' : 'tes-number'"
    input-type="number"
  />
</template>
<script>
import Checkbox from '@/app/components/Checkbox';
import InputField from '@/app/components/InputField';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import i18n from '@/i18n';
export default {
  name: 'TimeSheetEntry',
  components: {
    Checkbox,
    InputField
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: true
    },
    id: {
      type: String,
      default: ''
    }
  },
  computed: {
    unit: {
      set(value) {
        this.$emit('change', { ...this.value, unit: value });
      },
      get() {
        return this.value.unit;
      }
    },
    quantity: {
      set(value) {
        if (isNaN(value)) {
          this.$store.dispatch(TolErrorsActions.SetError, {
            message: i18n.t('timeSheets.details.errors.hoursNotNumeric')
          });
        } else if (value < 0 || value > 24) {
          this.$store.dispatch(TolErrorsActions.SetError, {
            message: i18n.t('timeSheets.details.errors.hoursGreatherThanTwentyFourOrLessThanZero')
          });
        } else {
          this.$emit('change', { ...this.value, quantity: value });
        }
      },
      get() {
        return this.value.quantity;
      }
    }
  },
  methods: {
    onDailyChange(event) {
      this.quantity = event.checked ? 1 : 0;
    },
    setCEValue(event) {
      this.$emit('change', { ...this.value, quantity: event });
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.tes-number,
.tes-number-input {
  height: 3em;
  width: 4em;
  font-size: inherit;
  text-align: center;
  border: 1px solid $row-border;
}
.tes-number-input {
  border: 1px solid $row-border;
}
</style>
